{
  document.addEventListener("DOMContentLoaded", function () {
    var swiper = new Swiper(".Banner_slider", {
      speed: 1000,
      parallax: true,
      //   loop: true
      grabCursor: true,
      autoplay: false,
      mousewheelControl: 1,
      effect: "slide",
      pagination: {
        paginationClickable: true,
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  });
}
// {
//   document.addEventListener("DOMContentLoaded", function () {
//     const MultipleSlider = () => {
//       const MultipleSliders = document.querySelectorAll(".ProductS_slid");
//       MultipleSliders.forEach((slider, index) => {
//         const prevArrow = slider.parentElement.querySelector(".prev");
//         const nextArrow = slider.parentElement.querySelector(".next");
//         new Swiper(slider, {
//           direction: "horizontal",
//           // loop: true,
//           speed: 1000,
//           //   autoplay: {
//           //     delay: 1000,
//           //     disableOnInteraction: false,
//           //   },
//           //   grabCursor: true,
//           navigation: {
//             nextEl: nextArrow,
//             prevEl: prevArrow,
//           },
//           breakpoints: {
//             150: {
//               slidesPerView: 1.4,
//               spaceBetween: 10,
//             },
//             576: {
//               slidesPerView: 2.8,
//               spaceBetween: 20,
//             },
//             769: {
//               slidesPerView: 3.4,
//               spaceBetween: 20,
//             },
//             1024: {
//               slidesPerView: 4,
//               spaceBetween: 20,
//             },
//             1201: {
//               slidesPerView: 5,
//               spaceBetween: 20,
//             },
//           },
//         });
//       });
//     };
//     MultipleSlider();
//   });
// }

document.addEventListener("DOMContentLoaded", function () {
  const MultipleSlider = () => {
    const MultipleSliders = document.querySelectorAll(".ProductS_slid");

    MultipleSliders.forEach((slider) => {
      const prevArrow = slider.parentElement.querySelector(".prev");
      const nextArrow = slider.parentElement.querySelector(".next");

      new Swiper(slider, {
        direction: "horizontal",
        speed: 1000,
        navigation: {
          nextEl: nextArrow,
          prevEl: prevArrow,
        },
        breakpoints: {
          150: {
            slidesPerView: 1.4,
            spaceBetween: 10,
          },
          576: {
            slidesPerView: 2.8,
            spaceBetween: 20,
          },
          769: {
            slidesPerView: 3.4,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1201: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
        },
        on: {
          init(swiper) {
            handleJustify(swiper);
          },
          resize(swiper) {
            handleJustify(swiper);
          },
        },
      });
    });

    function handleJustify(swiper) {
      const swiperWrapper = swiper.el.querySelector(".swiper-wrapper");
      const slidesCount = swiper.slides.length;
      const perView = swiper.params.slidesPerView;

      if (slidesCount < perView) {
        swiperWrapper.classList.add("center-slides");
      } else {
        swiperWrapper.classList.remove("center-slides");
      }
    }
  };

  MultipleSlider();
});

{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".testi_sliders");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          loop: true,
          speed: 5000,
          slidesPerView: "auto",
          spaceBetween: 16,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          // breakpoints: {
          //   150: {
          //     slidesPerView: 1.5,
          //     spaceBetween: 10,
          //   },
          //   576: {
          //     slidesPerView: 2.4,
          //     spaceBetween: 20,
          //   },
          //   769: {
          //     slidesPerView: 3,
          //     spaceBetween: 20,
          //   },
          //   1025: {
          //     slidesPerView: 3.5,
          //     spaceBetween: 20,
          //   },
          //   1200: {
          //     slidesPerView: 3.5,
          //     spaceBetween: 20,
          //   },
          // },
        });
      });
    };
    MultipleSlider();
  });
}


{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".tabsSwiper");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          speed: 500,
          slidesPerView: "auto",
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          // breakpoints: {
          //   150: {
          //     spaceBetween: 20,
          //   },
          //   576: {
          //     spaceBetween: 30,
          //   },
          //   769: {
          //     spaceBetween: 35,
          //   },
          //   1025: {
          //     spaceBetween: 48,
          //   },
          // },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".exclusive_Slide");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          speed: 1000,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            769: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".listing_slider").forEach((slider, index) => {
      const wrapper = slider.querySelector(".swiper-wrapper");
      const slides = slider.querySelectorAll(".swiper-slide");
      const clones = parseInt(slider.dataset.cloneMultiplier, 1) || 1;
      for (let i = 0; i < clones; i++) {
        slides.forEach((s) => wrapper.appendChild(s.cloneNode(true)));
      }
      console.log(
        `Slider #${index + 1}: total slides ${
          wrapper.querySelectorAll(".swiper-slide").length
        }`
      );
      new Swiper(slider, {
        slidesPerView: "auto",
        loop: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        grab: true,
        speed: 3000,
        breakpoints: {
            150: {
              spaceBetween: 10,
            },
            769: {
             spaceBetween: 16,
            },
          },
      });
    });
  });
}